import { Stack, Button, Grid } from '@mui/material'
import { Fragment, useContext, useEffect, useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { useUploadEmployeesMutation } from '@/api'
import { DrawerBox } from '@/components'
import { useRole } from '@/hooks'
import { DownloadIcon } from '@/modules/MedReports/Reports/assets/DownloadIcon'
import { OrganizationContext } from '@/modules/Organization/Organization'
import { showAddNotice } from '@/modules/Organization/Tabs/Employees/modules/EmployeesList/components/AddNotice/showAddNotice'
import { useAppDispatch } from '@/store'
import { setEmployeesImportNotification } from '@/store/app'
import { FileDocument } from './components/FilesDocument'
import { SuccessIcon } from './components/SuccessIcon'
import { WarningIcon } from './components/WarningIcon'
import type { ImportEmployeesDrawerProps } from './types'

export const ImportEmployeesDrawer = (props: ImportEmployeesDrawerProps) => {
  const { open, setOpen } = props
  const { organizationId } = useContext(OrganizationContext)
  const { hasRole } = useRole()
  const [deletedFiles, setDeletedFiles] = useState<number[]>([])
  const [newFiles, setNewFiles] = useState<File[]>([])
  const methods = useForm()
  const watchFiles = methods.watch('files')

  const dispatch = useAppDispatch()
  const [uploadEmployees] = useUploadEmployeesMutation()
  const isClientAdmin = hasRole(['Администратор клиента'])

  const [errorText, setErrorText] = useState<string | undefined>()

  const handleClose = () => {
    setErrorText(undefined)
    setOpen(false)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSubmit = async (value: any) => {
    const formData = new FormData()
    formData.append('file', value.files[0])

    if (value?.files?.length === 1) {
      setErrorText(undefined)
      try {
        uploadEmployees({ id: organizationId, payload: formData }).then(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (response: any) => {
            console.log(response)

            if (
              response?.data?.errors &&
              Array.isArray(response?.data?.errors)
            ) {
              void showAddNotice({
                title: `Не всех сотрудников удалось добавить!`,
                contentText: (
                  <div>
                    <div>
                      Было добавлено {response?.data?.createdEmployees || 0}{' '}
                      сотрудников
                    </div>
                    <br />
                    <div>
                      <b>Ошибки добавления:</b>
                    </div>
                    {response.data.errors.map((text: string, i: string) => (
                      <div key={i}>{text}</div>
                    ))}
                  </div>
                ),
              })
            } else if (
              response?.data?.createdUsers !== 0 &&
              response?.data?.createdEmployees !== 0 &&
              response?.data?.createdStaffRoles !== 0
            ) {
              dispatch(
                setEmployeesImportNotification({
                  text: `Сотрудники успешно загружены. Кол-во: ${response?.data?.createdEmployees}`,
                  icon: <SuccessIcon />,
                })
              )
              methods.setValue('files', [])
            } else {
              dispatch(
                setEmployeesImportNotification({
                  text: 'Не удалось загрузить сотрудников.',
                  icon: <WarningIcon />,
                })
              )
            }
          }
        )
      } catch (error) {
        dispatch(
          setEmployeesImportNotification({
            text: 'Не удалось загрузить сотрудников.',
            icon: <WarningIcon />,
          })
        )
      }
      setOpen(false)
    } else if (value?.files?.length < 1) {
      setErrorText('Файл не загружен')
    } else if (value?.files?.length > 1) {
      setErrorText('Добавлено больше одного файла')
    }
  }

  return (
    <Fragment>
      <DrawerBox
        opened={open}
        onClose={() => setOpen(false)}
        bottom={
          <Stack gap={1.5}>
            <Button
              onClick={methods.handleSubmit(onSubmit)}
              variant={'contained'}
              //color="info"
              type={'submit'}
              // disabled={watchFiles?.length !== 1}
            >
              Загрузить
            </Button>
            <Button
              variant={'contained'}
              color={'primary'}
              onClick={handleClose}
            >
              Отмена
            </Button>
          </Stack>
        }
        title={'Загрузить список сотрудников организации'}
      >
        <FormProvider {...methods}>
          <form>
            <Grid spacing={3} container style={{ marginTop: 'auto' }}>
              <Grid item sm={12} style={{ paddingTop: '4px' }}>
                При загрузке сотрудников, не покидайте текущую страницу, не
                закрывайте браузер до получения уведомления об успешной загрузке
                или ошибке. В случае возникновения ошибки, необходимо проверить
                соответствие загружаемых данных с шаблоном.
              </Grid>
              <Grid item sm={12}>
                <a
                  href={
                    isClientAdmin
                      ? '/documents/Шаблон на добавление сотрудников (Администратор клиента).xlsx'
                      : '/documents/Шаблон на добавление сотрудников.xlsx'
                  }
                  download={
                    isClientAdmin
                      ? 'Шаблон на добавление сотрудников (Администратор клиента).xlsx'
                      : 'Шаблон на добавление сотрудников.xlsx'
                  }
                >
                  <Button
                    style={{ width: '100%' }}
                    variant={'contained'}
                    color={'primary'}
                    startIcon={<DownloadIcon />}
                    onClick={() => {}}
                  >
                    Скачать шаблон
                  </Button>
                </a>
              </Grid>
              <Grid item sm={12}>
                <FileDocument
                  setDeletedFiles={setDeletedFiles}
                  setNewFiles={setNewFiles}
                  errorText={errorText}
                />
              </Grid>
              {/* <div
                style={{
                  marginTop: '12px',
                  padding: '0px 24px',
                  color: 'red',
                }}
              >
                {'файл не загружен'}
                {'добавлено больше одного файла'}
              </div> */}
            </Grid>
          </form>
        </FormProvider>
      </DrawerBox>
    </Fragment>
  )
}
